<template>
  <div class="w-full">
    <h4 class="mb-5 text-sm leading-6 text-center text-gray-900 border-b">Allegati</h4>
    <vue-dropzone
      ref="dropzone"
      id="files-dropzone"
      :options="dropzoneOptions"
      @vdropzone-success="upload_success"
      @vdropzone-error="upload_error"
      :useCustomSlot="true"
      :includeStyling="false"
    >
      <div class="my-5">
        <file
          v-for="(file, index) in this.files"
          :file="file"
          :index="index"
          :key="file.id"
          @remove="remove_file"
        ></file>
      </div>
      <button class="w-full px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-700">Carica</button>
    </vue-dropzone>
  </div>
</template>
<script type="text/javascript">
import { mapState } from "vuex";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import FileAPI from "../../../api/file.js";
import File from "./File.vue";

export default {
  props: {
    patient_id: {
      require: true,
    },
    examination_id: {
      required: false,
    },
  },

  components: {
    File,
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("file", ["files"]),
    ...mapState("patient", ["patient"]),
    ...mapState("examination", ["examination"]),
    dropzoneOptions() {
      let token = document.head.querySelector('meta[name="csrf-token"]')
        .content;
      return {
        url: FileAPI.uploadURL(this.patient_id, this.examination_id),
        thumbnailWidth: 150,
        dictDefaultMessage: "<i class='cloud upload icon'></i>CARICA",
        addRemoveLinks: true,
        headers: {
          "X-CSRF-Token": token,
          Authorization: "Bearer " + (this.user ? this.user.access_token : ""),
        },
      };
    },
  },

  methods: {
    upload_success(file_element, file) {
      this.$refs.dropzone.removeFile(file_element);
      this.$store.dispatch("file/add", file);
    },
    upload_error(file_element, message, xhr) {
      this.$refs.dropzone.removeFile(file_element);
    },
    remove_file(data) {
      if (confirm("Sicuro di voler cancellare il file?")) {
        this.$store.dispatch("file/delete", {
          id: this.files[data.index].id,
        });
        this.files.splice(data.index, 1);
      }
    },
  },

  mounted() {
    this.$store.dispatch("file/load", {
      patient_id: this.patient_id,
      examination_id: this.examination_id,
    });
  },
};
</script>
